import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { ModeloVehiculoFindOneInterface } from "../../interfaces/modelovehiculosinterfaces/ModeloVehiculoFindOne.interface";

export async function FinOneModeloVehiculoAction (
    ModeloId: string
): Promise<ApiResponse<ModeloVehiculoFindOneInterface>> {
   const {data} = await apiClient.get(`gvModeloVehiculos/${ModeloId}`);
    return {
        status: 200,
        data,
        message: "Modelo de vehiculo obtenida correctamente",
    };
}